import React, { useState } from "react";
import styled from "styled-components";
import Layout from "../common/Layout";
import { Container } from "react-bootstrap";
import SettingsRender from '../admin/SettingsView/SettingsRender';

const SettingsPage = () => {
  const [activeModal, ] = useState(false);

  return (
    <Layout navType="admin" hasBackground>
      <StyledDashboardPage activeModal={activeModal}>
        <Container>
          <SettingsRender pageType="admin"/>
        </Container>
      </StyledDashboardPage>
    </Layout>
  );
};

const StyledDashboardPage = styled.div``;

export default SettingsPage;
